import { closeOpenDemoShareEngagement } from '../Screens/Demo/demoShareEngagement';

const DEMO_FLOW_KEY = 'demoFlow';

export const markDemoFlow = () => {
  sessionStorage.setItem(DEMO_FLOW_KEY, 'true');
};

export const isDemoFlow = () => sessionStorage.getItem(DEMO_FLOW_KEY) === 'true';

export const clearDemoFlow = () => {
  sessionStorage.removeItem(DEMO_FLOW_KEY);
};

/**
 * Demo-window logout: close the tab without clearing auth.
 * Returns true when handled as demo flow.
 */
export const closeDemoWindowIfNeeded = () => {
  if (!isDemoFlow()) return false;
  // Best-effort link close before leaving the live demo app.
  closeOpenDemoShareEngagement({ useKeepalive: true });
  clearDemoFlow();
  window.close();
  // Fallback when the browser blocks window.close()
  window.location.href = '/demo';
  return true;
};
